<template>
  <div>
    <template v-if="isEmpty(formatData)">-</template>
    <!-- 歌词 -->
    <template v-else-if="isLyric">
      <a :href="formatData" target="_blank" style="color: #4071ff">下 载</a>
    </template>

    <!-- 图片 -->
    <pic-preview v-else-if="isPic" :photo-url="formatData"></pic-preview>

    <!-- 音频 -->
    <online-listen
      v-else-if="isMedia"
      :media="formatData.media"
      :track-name="formatData.trackName"
      class="prelisten"
      @click.stop.prevent
    ></online-listen>

    <!-- 歌手 -->
    <singer-cell v-else-if="isSinger" :singer-list="formatData" show-detail></singer-cell>

    <template v-else>无法识别媒体文件</template>
  </div>
</template>

<script>
import { isArray, isEmpty } from 'lodash-es'
import PicPreview from '@/components/PicPreview/index.vue'
import OnlineListen from '@/components/OnlineListen/index.vue'
import SingerCell from '@/components/SingerCell/index.vue'

const mediaTypeList = ['picture', 'lyric', 'media', 'singer']

export default {
  name: 'MediaItem',
  components: {
    PicPreview,
    OnlineListen,
    SingerCell
  },
  props: {
    mediaType: {
      type: String,
      default: 'picture',
      validator: (val) => {
        return mediaTypeList.includes(val)
      }
    },
    data: [String, Object, Array]
  },
  data() {
    return {
      formatData: ''
    }
  },
  computed: {
    isPic() {
      return this.mediaType === 'picture'
    },
    isLyric() {
      return this.mediaType === 'lyric'
    },
    isMedia() {
      return this.mediaType === 'media'
    },
    isSinger() {
      return this.mediaType === 'singer'
    }
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        switch (this.mediaType) {
          case 'picture':
          case 'lyric':
            this.formatData = val ?? ''
            break
          case 'media':
            this.formatData = {
              trackName: val?.trackName ?? '',
              media: val?.media ?? null
            }
            break
          case 'singer':
            this.formatData = isArray(val) ? val : isEmpty(val) ? [] : [val]
            break
          default:
            break
        }
      }
    }
  },

  methods: {
    isEmpty
  }
}
</script>
